<template>
    <li>
        <a :href="team_base_route + team.contestant_id" class="clearfix">
            <span class="badge"><img :src="team.logo_path"></span>
            <span class="name">{{ team.club_name }}</span>
        </a>
    </li>
</template>

<script>
    export default {
        props: ['team', 'team_base_route'],
    }
</script>
